/* eslint-disable security/detect-object-injection */
import React, { useContext, useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {  EntityUtil } from '@xengage/gw-portals-util-js';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, screenReaderAnnounce, focusNextElement, validationUtil } from 'premier-capability-hooks';
import { TranslatorContext } from '@jutro/locale';
import styles from './BoatsPage.module.scss';
import presentationMetadata from './BoatsPage.metadata.json5';
import messages from './BoatsPage.messages';
import  BoatTabSetComponent  from "../../components/Boats/BoatTabSetComponent/BoatTabSetComponent";

function BoatsPage(props) {
    const {
        wizardData, updateWizardData, currentStep, callbackMap, viewModelService
    } = props;
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('BoatsPage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const [accordionStates, updateAccordionStates] = useState([]);
    const { lineName } = PremierConstants;
    const translator = useContext(TranslatorContext);
   

    const onNext = useCallback(
        async () => {

            const {productCode} = wizardData.value.baseData;
            const lobLineName = lineName[productCode];

            wizardData.value = await updateSubmission(lobLineName, 'BoatsPage', wizardData);

            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );

    const onSave = useCallback(
        async () => {

            const subVMCopy = _.clone(wizardData)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.recMarLine.coverables.boats.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'BoatsPage', subVMCopy);
                            
            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );

    const addBoat = useCallback(async () => {

            const boatObj = {
                tempID: EntityUtil.nextId()
            };

            const { _xCenter, _dtoName } = wizardData.lobData.recMarLine.coverables.boats;

            let boatVM = viewModelService.create(boatObj, _xCenter, _dtoName);
            
            wizardData.lobData.recMarLine.coverables.boats.value = wizardData.lobData.recMarLine.coverables.boats.value || []
            
            boatVM = {
                boatInformation: {},
                additionalInformation: {},
                navigation: {},
                mooringLayup: {},
                highPerformanceVessel: {},
                additionalParts: {},
                extendedNavigation: {
                    tripDetails: [],
                    crewMembers: [],
                    marinaDetails: []
                }
            }

            wizardData.lobData.recMarLine.coverables.boats.pushElement(
                boatVM
            );
            updateWizardData(wizardData);
            screenReaderAnnounce('Boat details fields have been populated');
            updateAccordionStates([`BoatsAccordionCard_${wizardData.lobData.recMarLine.coverables.boats.value.length}`]);
            focusNextElement(true, 0, 'yeaFie');
        },
        [wizardData, viewModelService, updateWizardData]
    );

    const boatOverrides = useMemo(() => {
        const boatList = _.get(wizardData, 'lobData.recMarLine.coverables.boats', []);
        let overrides = [];

        if (!_.isEmpty(boatList)) {
            overrides = boatList?.children.map((boat, index) => ({
                    [`boatTabSetComponent${index}`]: {
                        overrideProps: {
                            "@field": {
                                // apply to all fields
                                showRequired: true,
                                labelPosition: "left",
                            },
                        },
                        submissionVM: wizardData,
                        updateWizardData,
                        pathUpdated: `lobData.recMarLine.coverables.boats.children[${index}]`,
                        offeringCode: wizardData.value.lobData.recMarLine.selectedOffering_Ext,
                        boatVm : boat,
                        index,
                        viewModelService
                    },
                    [`BoatsAccordionCard${index}`]: {
                        title: translator(messages.boatCount, { count: `${index + 1}` }),
                        id: `BoatsAccordionCard_${index + 1}`
                    }
                }));
        }

        return Object.assign({}, ...overrides);
    }, [translator, updateWizardData, viewModelService, wizardData]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        boatsAccordionSet: {
            path: 'lobData.recMarLine.coverables.boats.children',
             onUpdateAccordionStates: (accordionStateList) => updateAccordionStates(accordionStateList),
            accordionStates
        },
        ...boatOverrides,
    };

    const resolveCallbackMap = {
        addBoat,
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, wizardData, id, path, overrideProps),
        [metadata.content, wizardData, overrideProps]
    );

    const resolveComponentMap = {
        boatTabSetComponent:BoatTabSetComponent
    };

    const isDisableNext = () => _.get(wizardData, 'lobData.recMarLine.coverables.boats') ? !_.get(wizardData, 'lobData.recMarLine.coverables.boats').aspects.subtreeValid : true;

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            onNext={onNext}
            onSave={onSave}
        >           
        <ViewModelForm
            uiProps={metadata.content}
            model={wizardData}
            onModelChange={updateWizardData}
            callbackMap={resolveCallbackMap}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            componentMap={resolveComponentMap}
            classNameMap={styles}
        />          
        </WizardPage>
    );
}

BoatsPage.propTypes = wizardProps;
export default withViewModelService(BoatsPage);
